import { render, staticRenderFns } from "./PageFooterSponsorOrPartner.vue?vue&type=template&id=b1febbb4"
import script from "./PageFooterSponsorOrPartner.vue?vue&type=script&lang=js"
export * from "./PageFooterSponsorOrPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports